// extracted by css-extract-rspack-plugin
export default {"datesWrapper":"_d8d42f16","date":"_68e3d2b6","shippingDelayed":"_b09b6824","trackingInfo":"_ba239763","deliveryDate":"_f210e78a"};